import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@node-space/ui-components'

export const LoginFooter = () => {
  const { t } = useTranslation()

  return (
    <Box paddingB={16}>
      <Text variant="caption-text" color="faint" isCentered>
        {`${t('recaptcha.protected')}`}
        <br />© 2017 - {new Date().getFullYear()} BVNK. {`${t('allRightsReserved')}`}
      </Text>
    </Box>
  )
}
